export default "__VITE_ASSET__a6ba8c6b__"